import { ReactNode } from 'react';

interface ContactInfoRowProps {
  label: string;
  children: ReactNode;
}

export function ContactInfoRow({ label, children }: ContactInfoRowProps) {
  return (
    <div className="grid grid-cols-2 gap-4 py-3 border-b border-border last:border-b-0 items-start">
      <span className="text-sm opacity-50">{label}</span>
      <div className="text-sm">
        {children}
      </div>
    </div>
  );
}
